import CommentsListView from './CommentsListView';

export default CommentsListView;
